// Auth routes
export const COUNT = 10;
export const AUTH_ROUTES = {
  login: {
    endPoint: "auth/login",
    method: "POST",
  },
  logout: {
    endPoint: "auth/logout",
    method: "POST",
  },
  me: {
    endPoint: "auth/me",
    method: "POST",
  },
  update: {
    endPoint: "user/update-profile",
    method: "POST",
  },
  forgot: {
    endPoint: "auth/password/email",
    method: "POST",
  },
  reset: {
    endPoint: "auth/password/reset",
    method: "POST",
  },
  check: {
    endPoint: "auth/check",
    method: "POST",
  },
};

export const GOAL_ROUTES = {
  createGoal: {
    endPoint: "goals",
    method: "POST",
  },
  getGoals: {
    endPoint: "goals/{id}",
    method: "GET",
  },
};

export const DIAGNOSTIC_ROUTES = {
  createDiagnostic: {
    endPoint: "diagnostics",
    method: "POST",
  },
};

export const RDV_ROUTES = {
  list: {
    endPoint: "rdv/list?rows=" + COUNT,
    method: "POST",
  },
};
// User routes
export const USER_ROUTES = {
  list: {
    endPoint: "user/list",
    method: "GET",
  },
  get: {
    endPoint: "user/get/{id}",
    method: "GET",
  },
  create: {
    endPoint: "user/create",
    method: "POST",
  },
  update: {
    endPoint: "user/update/{id}",
    method: "POST",
  },
  delete: {
    endPoint: "user/delete/{id}",
    method: "POST",
  },
};

// Instituts routes
export const INSTITUT_ROUTES = {
  list: {
    endPoint: "institut/list",
    method: "GET",
  },
  get: {
    endPoint: "institut/get/{id}",
    method: "GET",
  },
  create: {
    endPoint: "institut/create",
    method: "POST",
  },
  update: {
    endPoint: "institut/update/{id}",
    method: "POST",
  },
  delete: {
    endPoint: "institut/delete/{id}",
    method: "POST",
  },
  unlink: {
    endPoint: "institut/unlink/treatwell/{id}",
    method: "GET",
  },

  createPrestation: {
    endPoint: "institut/institutPrestation",
    method: "POST",
  },
  getInstitutPrestation: {
    endPoint: "institut/getInstitutPrestation",
    method: "POST",
  },
};

// Praticiens routes
export const PRATICIENS_ROUTES = {
  list: {
    endPoint: "praticienne/list",
    method: "GET",
  },
  get: {
    endPoint: "praticienne/get/{id}",
    method: "GET",
  },
  create: {
    endPoint: "praticienne/create",
    method: "POST",
  },
  update: {
    endPoint: "praticienne/update/{id}",
    method: "POST",
  },
  delete: {
    endPoint: "praticienne/delete/{id}",
    method: "POST",
  },
};

// Pre-inscriptions routes
export const PRE_INSCRIPTIONS_ROUTES = {
  list: {
    endPoint: "pre-inscriptions/list?rows=" + COUNT,
    method: "POST",
  },
};

// Compte routes
export const COMPTE_ROUTES = {
  list: {
    endPoint: "compte/list?rows=" + COUNT,
    method: "POST",
  },
  get: {
    endPoint: "compte/get/{id}",
    method: "GET",
  },
  all: {
    endPoint: "compte/all",
    method: "GET",
  },
  cards: {
    endPoint: "compte/card/all",
    method: "GET",
  },
  delete: {
    endPoint: "compte/delete/{id}",
    method: "POST",
  },
  update: {
    endPoint: "compte/update/{id}",
    method: "POST",
  },
  create: {
    endPoint: "compte/create",
    method: "POST",
  },
  addpoints: {
    endPoint: "fidelite/affect",
    method: "POST",
  },
  reducepoints: {
    endPoint: "fidelite/deduire",
    method: "POST",
  },
  sendNotif: {
    method: 'POST',
    endPoint: 'compte/send-notif',
  },
};

export const COUPON_ROUTES = {
  list: {
    endPoint: "coupon/list",
    method: "GET"
  },
  create: {
    endPoint: "coupon/create",
    method: "POST"
  },
  update: {
    endPoint: "coupon/update/{id}",
    method: "PUT"
  },
  delete: {
    endPoint: "coupon/delete/{id}",
    method: "DELETE"
  },
};


// Produit routes
export const PRODUIT_ROUTES = {
  list: {
    endPoint: "produit/list",
    method: "GET",
  },
  create: {
    endPoint: "produit/create",
    method: "POST",
  },
  get: {
    endPoint: "produit/get/{id}",
    method: "GET",
  },
  update: {
    endPoint: "produit/update/{id}",
    method: "POST",
  },
  delete: {
    endPoint: "produit/delete/{id}",
    method: "POST",
  },
  publier: {
    endPoint: "produit/publier/{id}",
    method: "POST",
  },
  new: {
    endPoint: "produit/toggle-new/{id}",
    method: "POST",
  },
  draft: {
    list: {
      endPoint: "produit/drafts",
      method: "GET",
    },
    get: {
      endPoint: "produit/draft/{id}",
      method: "GET",
    },
    validate: {
      endPoint: "produit/draft/validate/{id}",
      method: "POST",
    },
    togglePublish: {
      endPoint: "produit/draft/publish/{id}",
      method: "GET",
    },
  },
};

// Category routes
export const CATEGORY_ROUTES = {
  list: {
    endPoint: "categorie/list",
    method: "POST",
  },
  listWithSub: {
    endPoint: "categorie/list-subcategories",
    method: "GET",
  },
  create: {
    endPoint: "categorie/create",
    method: "POST",
  },
  get: {
    endPoint: "categorie/get/{id}",
    method: "GET",
  },
  update: {
    endPoint: "categorie/update/{id}",
    method: "POST",
  },
  delete: {
    endPoint: "categorie/delete/{id}",
    method: "POST",
  },
  items: {
    list: {
      endPoint: "categorie/{id}/items",
      method: "GET",
    },
    attach: {
      endPoint: "categorie/{id}/attach/items",
      method: "POST",
    },
    detach: {
      endPoint: "categorie/{id}/detach/items",
      method: "POST",
    },
  },
  subCategories: {
    create: {
      endPoint: "sous_categorie/create",
      method: "POST",
    },
    update: {
      endPoint: "sous_categorie/update/{id}",
      method: "POST",
    },
    delete: {
      endPoint: "sous_categorie/delete/{id}",
      method: "POST",
    },
  },
};

//item images routes

export const ITEM_ROUTES = {
  delete: {
    endPoint: "common/delete-image",
    method: "POST",
  },
};
// Prestation routes
export const PRESTATION_ROUTES = {
  list: {
    endPoint: "prestation/list",
    method: "GET",
  },
  create: {
    endPoint: "prestation/create",
    method: "POST",
  },
  get: {
    endPoint: "prestation/get/{id}",
    method: "GET",
  },
  update: {
    endPoint: "prestation/update/{id}",
    method: "POST",
  },
  delete: {
    endPoint: "prestation/delete/{id}",
    method: "POST",
  },
  items: {
    list: {
      endPoint: "prestation/{id}/categories",
      method: "GET",
    },
    attach: {
      endPoint: "prestation/{id}/attach/categories",
      method: "POST",
    },
    detach: {
      endPoint: "prestation/{id}/detach/categories",
      method: "POST",
    },
  },
};

export const PACK_ROUTES = {
  list: {
    endPoint: "enviemoment/list",
    method: "GET",
  },
  create: {
    endPoint: "enviemoment/create",
    method: "POST",
  },
  get: {
    endPoint: "enviemoment/get/{id}",
    method: "GET",
  },
  update: {
    endPoint: "enviemoment/update/{id}",
    method: "POST",
  },
  delete: {
    endPoint: "enviemoment/delete/{id}",
    method: "POST",
  },
  attach: {
    endPoint: "enviemoment/{id}/attach/items",
    method: "POST",
  },
  detach: {
    endPoint: "enviemoment/{id}/detach/items",
    method: "POST",
  },
};

export const TAG_ROUTES = {
  list: {
    endPoint: "tag/list",
    method: "GET",
  },
  create: {
    endPoint: "tag/create",
    method: "POST",
  },
  get: {
    endPoint: "tag/get/{id}",
    method: "GET",
  },
  update: {
    endPoint: "tag/update/{id}",
    method: "POST",
  },
  delete: {
    endPoint: "tag/delete/{id}",
    method: "POST",
  },
};

export const HISTORIQUE_ROUTES = {
  list: {
    endPoint: "historique/list",
    method: "GET",
  },
  create: {
    endPoint: "historique/create",
    method: "POST",
  },
  get: {
    endPoint: "historique/get/{id}",
    method: "GET",
  },
  update: {
    endPoint: "historique/update/{id}",
    method: "POST",
  },
  delete: {
    endPoint: "historique/delete/{id}",
    method: "POST",
  },
};

export const BON_PLAN_ROUTES = {
  list: {
    endPoint: "bonplan/list",
    method: "GET",
  },
  create: {
    endPoint: "bonplan/create",
    method: "POST",
  },
  get: {
    endPoint: "bonplan/get/{id}",
    method: "GET",
  },
  update: {
    endPoint: "bonplan/update/{id}",
    method: "POST",
  },
  delete: {
    endPoint: "bonplan/delete/{id}",
    method: "POST",
  },
  items: {
    list: {
      endPoint: "bonplan/{id}/items",
      method: "GET",
    },
    attach: {
      endPoint: "bonplan/{id}/attach/items",
      method: "POST",
    },
    detach: {
      endPoint: "bonplan/{id}/detach/items",
      method: "POST",
    },
  },
};

export const HISTORIQUE_POINTS_ROUTES = {
  get: {
    endPoint: "compte/movement-points/{id}",
    method: "POST",
  },
};
export const MARQUES_ROUTES = {
  publie: {
    endPoint: "marque/publier/{id}",
    method: "POST",
  },
  epingle: {
    endPoint: "marque/epingler/{id}",
    method: "POST",
  },
  list: {
    endPoint: "marque/list",
    method: "GET",
  },
  get: {
    endPoint: "marque/get/{id}",
    method: "GET",
  },
  delete: {
    endPoint: "/marque/delete/{id}",
    method: "POST",
  },
  create: {
    endPoint: "marque/create",
    method: "POST",
  },
  update: {
    endPoint: "marque/update/{id}",
    method: "POST",
  },
  order: {
    endPoint: "marque/{id}/ordre/produit",
    method: "POST",
  },
};

export const SALON_ROUTES = {
  list: {
    endPoint: "salon/list",
    method: "GET",
  },
  create: {
    endPoint: "salon/create",
    method: "POST",
  },
  get: {
    endPoint: "salon/get/{id}",
    method: "POST",
  },
  update: {
    endPoint: "salon/update/{id}",
    method: "POST",
  },
  delete: {
    endPoint: "salon/delete/{id}",
    method: "POST",
  },
  productsAndPrestations: {
    endPoint: "common/prestations-produits",
    method: "GET",
  },
  activate: {
    endPoint: "salon/activate/{id}",
    method: "POST",
  },
  preview_draft: {
    endPoint: "salon/draft/get/{id}",
    method: "GET",
  },
  apply_draft: {
    endPoint: "salon/draft/apply/{id}",
    method: "GET",
  },
};
export const PANNEAU_ROUTES = {
  list: {
    endPoint: "panneau-affichage/list",
    method: "GET",
  },
  update: {
    endPoint: "panneau-affichage/update-zone",
    method: "POST",
  },
  apply_drafts: {
    endPoint: "panneau-affichage/apply/drafts",
    method: "GET",
  },
  get_drafts: {
    endPoint: "panneau-affichage/get/drafts",
    method: "GET",
  },
};

export const STATISTIQUE_ROUTES = {
  kpis: {
    endPoint: "statistique/kpis",
    method: "GET",
  },
  kpisFiltered: {
    endPoint: "statistique/kpis",
    method: "POST",
  },
  metrics: {
    endPoint: "statistique/metrics",
    method: "POST",
  },
};
export const LIVRAISON_ROUTES = {
  list: {
    endPoint: "livraison-mode/list",
    method: "GET",
  },
  create: {
    endPoint: "livraison-mode/create",
    method: "POST",
  },
  update: {
    endPoint: "livraison-mode/update/{id}",
    method: "POST",
  },
  delete: {
    endPoint: "livraison-mode/delete/{id}",
    method: "GET",
  },
};

export const COMMANDE_ROUTES = {
  list: {
    endPoint: "commande/list?rows=" + COUNT,
    method: "POST",
  },
  statut: {
    endPoint: "commande/change/statut/{id}",
    method: "POST",
  },
};
export const RETURNS_ROUTES = {
  list: {
    endPoint: "product-return/list",
    method: "GET",
  },
  status: {
    endPoint: "product-return/change/statut/{id}",
    method: "POST",
  },
};
export const DISCUSSIONS_ROUTES = {
  list: {
    endPoint: "discussion/list",
    method: "POST",
  },
  send: {
    endPoint: "discussion/{id}/new/message",
    method: "POST",
  },
  product_return_chat: {
    endPoint: "discussion/product-return/{id}",
    method: "GET",
  },
  product_return_send: {
    endPoint: "discussion/product-return/{id}/new/message",
    method: "POST",
  },
};
